import { MaskIcon } from '@/components/ui/MaskIcon';

import { ELEMENTS } from '../elements/registry';

/**
 * The "Add Elements" palette down the left of the questionnaire builder.
 *
 * A FLAT LIST, matching the designer. The previous version grouped the elements under six
 * collapsible headings — Layout, Input Fields, Selections, Advanced, Files & Media,
 * Verifications — of which four were permanently empty, so half the panel was headings that
 * opened onto nothing. The designer's own panel has no grouping at all, and with seventeen
 * entries there is nothing to group away.
 *
 * Every entry comes from the element registry, so the palette cannot fall out of step with what
 * the config panel and renderer support.
 */
export function QuestionnairesSidebar({
  onAddElement,
}: {
  onAddElement: (fieldType: string) => void;
}) {
  // FLUSH white with a right border only — the designer's `.sc-questionnaires-sidebar`
  // (`bg-white border-r border-[#D0D4E4] shadow-xs`, no radius). Ours was a rounded card with a full
  // border floating on the grey page, so the panel read as a widget dropped onto the builder instead
  // of part of it.
  return (
    <div className="flex h-full w-full shrink-0 flex-col overflow-hidden border-e border-[#D0D4E4] bg-white shadow-2xs">
      <h3 className="shrink-0 px-4 pt-4 pb-3 text-[length:var(--text-16)] font-semibold tracking-tight text-black">
        Add Elements
      </h3>

      <div className="custom-scrollbar flex flex-1 flex-col gap-2 overflow-y-auto px-4 pb-4">
        {ELEMENTS.map((element) => (
          <button
            key={element.id}
            type="button"
            onClick={() => onAddElement(element.id)}
            className="group flex w-full shrink-0 items-center gap-3 rounded-lg border border-grayEF bg-white px-[clamp(10px,1vw,14px)] py-[clamp(10px,1vw,12.5px)] text-left text-[length:var(--text-14)] font-medium text-black-logo transition-all duration-150 hover:border-primary hover:text-primary"
          >
            {/* Masked, not <img>: the artwork's colour is baked in, so masking is what lets the
                icon turn blue with the row's text on hover. */}
            <MaskIcon
              src={element.icon}
              className="h-4 w-4 shrink-0 text-gray66 group-hover:text-primary"
            />
            <span className="select-none truncate text-left">{element.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
